/* tslint:disable */
import {
  CompanyAccount,
  UserProfile
} from '../index';

declare var Object: any;
export interface PropertyCaretakerInterface {
  "property_id": number;
  "caretaker_id": number;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  property?: CompanyAccount;
  caretaker?: UserProfile;
}

export class PropertyCaretaker implements PropertyCaretakerInterface {
  "property_id": number;
  "caretaker_id": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  property: CompanyAccount;
  caretaker: UserProfile;
  constructor(data?: PropertyCaretakerInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PropertyCaretaker`.
   */
  public static getModelName() {
    return "PropertyCaretaker";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PropertyCaretaker for dynamic purposes.
  **/
  public static factory(data: PropertyCaretakerInterface): PropertyCaretaker{
    return new PropertyCaretaker(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PropertyCaretaker',
      plural: 'PropertyCaretakers',
      path: 'PropertyCaretakers',
      idName: 'id',
      properties: {
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "caretaker_id": {
          name: 'caretaker_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        property: {
          name: 'property',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'property_id',
          keyTo: 'id'
        },
        caretaker: {
          name: 'caretaker',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'caretaker_id',
          keyTo: 'id'
        },
      }
    }
  }
}
